import { Pipe, PipeTransform } from "@angular/core";
import { ValidationErrors } from "@angular/forms";

const errorMessages: Record<string, string | ((error: any) => string)> = {
  required: "El campo es obligatorio",
  invalidFormat: (error) => `Se espera formato: ${error}`,
  notPhonenumber: () => `Se espera un número de teléfono válido`,
  minlength: ({ requiredLength }) => `Mínimo ${requiredLength} caracteres`,
  maxlength: ({ requiredLength }) => `Máximo ${requiredLength} caracteres`,
  numberLength: ({ intMinLength, intMaxLength }) =>
    `Mínimo ${intMinLength} y máximo ${intMaxLength} dígitos`,
  alphanumeric: () => `Use solo caracteres alfanuméricos`,
  alphabeticName: "Use solo letras y espacios",
  invalidUsername:
    "Use sólo minúsculas (puede incluir números, guiones, punto ó @ entre letras)",
  invalidEmail: "Use un correo electrónico válido",
  onlyInt: "Use solo números enteros positivos",
  max: ({ max }) => `Máximo ${max}`,
  min: ({ min }) => `Mínimo ${min}`,
  maxDecimals: (res) => {
    return `Máximo ${res.max} decimales`;
  },
  invalidMCCMNC: () => `Debe ser un código numérico de 2-3 dígitos`,
};

@Pipe({
  name: "errorMessage",
})
export class ErrorMessagePipe implements PipeTransform {
  transform(
    errors: Record<string, ValidationErrors> | null
  ): string | undefined {
    if (!errors) return;
    console.log("Error message", errors);
    const errorKey = Object.keys(errors).find((key) => key in errorMessages);
    if (!errorKey) return "Valor inválido";

    const errorMessage = errorMessages[errorKey];
    return typeof errorMessage === "function"
      ? errorMessage(errors[errorKey])
      : errorMessage;
  }
}
